import {Bars} from 'react-loader-spinner'
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import Chart from '../../Chart/Chart';
import { authContext } from '../../Context/Authentication/authContext';
import './Population.scss';
import {baseURL} from '../../config';
import {generateChartData} from '../../Helpers/helpers'

const Population = () => {
  const { state }: any = useContext(authContext);
  const [chartData, setChartData]: any = useState(null);

  useEffect(() => {
    getPopulation();
  }, [state.filters.years, state.filters.city]);

  const getPopulation = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const city = JSON.stringify(state.filters.city)
      .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
      .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getPopulation?state=${state.filters.state}&city=${city}&startYear=${start}&endYear=${end}`
      );
      const data = generateChartData(response.data?.cube, 'population');
      setChartData(data);
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className='population-main'>
      {chartData?.length !== 0 && (
        <div className='population-main__text'>Population</div>
      )}
      {chartData === null ? (
        <div className='daysOnMarket-main__chartContainer__isLoading'>
          <Bars height='400' ariaLabel='bars-loading' wrapperClass='tab-spinner-progress-bar' visible={true}/>
        </div>
      ) : chartData?.length ? (
        <Chart
          chartData={chartData}
          title={'Population'}
          city={state.filters.city.sort()}
        />
      ) : (
        <div className='daysOnMarket-main__chartContainer__noData'>
          No Data Available
        </div>
      )}
    </div>
  );
};

export default Population;
